import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  FieldTemplateOne,
  renderFieldTemplateOne,
} from "../../PlantillasBloquesTabla"

const OperacionesEspecificas = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const fieldsPartOne: FieldTemplateOne[] = [
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box1"),
      code: "casilla230",
      inputNumber: "230",
      value: values?.casilla230,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box2"),
      code: "casilla109",
      inputNumber: "109",
      value: values?.casilla109,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box3"),
      code: "casilla231",
      inputNumber: "231",
      value: values?.casilla231,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box4"),
      code: "casilla232",
      inputNumber: "232",
      value: values?.casilla232,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box5"),
      code: "casilla111",
      inputNumber: "111",
      value: values?.casilla111,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box6"),
      code: "casilla113",
      inputNumber: "113",
      value: values?.casilla113,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box7"),
      code: "casilla523",
      inputNumber: "523",
      value: values?.casilla523,
    },
  ]

  const fieldsPartTwo = [
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box8"),
      code: "casilla654",
      inputNumber: "654",
      value: values?.casilla654,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box9"),
      code: "casilla655",
      inputNumber: "655",
      value: values?.casilla655,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box8"),
      code: "casilla656",
      inputNumber: "656",
      value: values?.casilla656,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.operacionesEspecificas.box10"),
      code: "casilla657",
      inputNumber: "657",
      value: values?.casilla657,
      disabled: true,
    },
  ]

  return (
    <div
      title='VolumenOperacion'
      className='tw-w-full tw-px-6'
    >
      {/* REVISAR COMO QUITAR ESTE GAP Y DEJAR ESPACIOS EN LAS DEMÁS RENDERIZADOS */}
      <div className='tw-flex tw-flex-col'>
        <p className='tw-font-medium tw-text-sm'>
          {t("taxSummary.declaracion.operacionesEspecificas.text1")}
        </p>
        {fieldsPartOne.map((field) => renderFieldTemplateOne(field, setValue))}
        <p className='tw-text-sm tw-col-span-6 tw-font-medium tw-pt-3'>
          {t("taxSummary.declaracion.operacionesEspecificas.text2")}
        </p>
        <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-3 tw-gap-3 tw-border-b tw-border-neutral-25'>
          <span className='tw-text-sm tw-col-span-3 tw-text-left'>
            {t("taxSummary.declaracion.operacionesEspecificas.text3")}
          </span>
          {fieldsPartTwo.slice(0, 2).map((field) => {
            return (
              <>
                <div className='tw-col-span-1'>
                  <div className='tw-flex tw-flex-col'>
                    <span className='tw-text-xs tw-text-left'>
                      {field.label}
                    </span>
                    <InputCurrencyGroup
                      suffix='€'
                      value={field.value as number}
                      placeholder='0,00'
                      className='tw-h-full tw-text-sm'
                      numberGroup={field.inputNumber}
                      disabled={field.disabled ?? false}
                    />
                  </div>
                </div>
              </>
            )
          })}
        </div>
        <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-3 tw-gap-3 tw-border-b tw-border-neutral-25'>
          <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-justify-start tw-items-center'>
            {t("taxSummary.declaracion.operacionesEspecificas.text4")}
          </span>
          {fieldsPartTwo.slice(2, 4).map((field) => {
            return (
              <>
                <div className='tw-col-span-1'>
                  <div className='tw-flex tw-flex-col'>
                    <span className='tw-text-xs tw-text-left'>
                      {field.label}
                    </span>
                    <InputCurrencyGroup
                      suffix='€'
                      value={field.value as number}
                      placeholder='0,00'
                      className='tw-h-full tw-text-sm'
                      numberGroup={field.inputNumber}
                      disabled={field.disabled ?? false}
                    />
                  </div>
                </div>
              </>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default OperacionesEspecificas
